import {Component} from '@angular/core';

@Component({
    selector: 'tfl-internal-exchange-transfer-icon',
    template: require('./internal-exchange.html')
})
export class InternalExchangeTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/internal/internal.exchnage.transfer.icon.ts